export default "#version 300 es\nprecision highp float;\n\nin vec4 rgba;\nout vec4 fragColor;\n\nvoid main() {\n  fragColor = rgba;\n}"